export default {
    '个人中心':'個人中心',  
    '编辑个人资料':'編輯個人資料',  
    '编辑个人领域信息':'編輯個人領域信息',  
    '本机构信息':'本機構信息',  
    '编辑机构信息':'編輯機構信息',  
    '设备管理':'設備管理',  
    '场所管理':'場所管理',  
    '关联设备':'關聯設備',  
    '学年学期':'學年學期',  
    '新增学年':'新增學年',  
    '编辑学年':'編輯學年',  
    '入学年份':'入學年份',  
    '班级管理':'班級管理',  
    '教职工':'教職工',  
    '新增教职工':'新增教職工',  
    '编辑教职工':'編輯教職工',  
    '市民':'市民',  
    '新增市民':'新增市民',  
    '编辑市民':'編輯市民',  
    '学生':'學生',  
    '新增学生':'新增學生',  
    '编辑学生':'編輯學生',  
    '家长':'家長',  
    '编辑家长':'編輯家長',  
    '角色管理':'角色管理',  
    '新增角色':'新增角色',  
    '编辑角色':'編輯角色',  
    '管理成员':'管理成員',  
    '测试管理':'測試管理',  
    '新增计划':'新增計劃',  
    '查看计划':'查看計劃',  
    '成绩查询':'成績查詢',  
    '测试记录':'測試記錄',  
    '锻炼记录':'鍛煉記錄',  
    '竞技排名赛':'競技排名賽',  
    '新增竞技排名赛':'新增競技排名賽',  
    '编辑竞技排名赛':'編輯競技排名賽',  
    '竞技排名赛详情':'競技排名賽詳情',  
    '竞技排名赛数据':'競技排名賽數據',  
    '作业管理':'作業管理',  
    '发布作业':'發佈作業',  
    '作业详情':'作業詳情',  
    '编辑作业':'編輯作業',  
    '测试结果':'測試結果',  
    '详情':'詳情',  
    '随堂练':'隨堂練',  
    '随堂测':'隨堂測',  
    '随堂赛':'隨堂賽',
    '个性化训练列表':'個性化訓練列表',  
    '新增个性化训练':'新增個性化訓練',  
    '查看个性化训练':'查看個性化訓練',  
    '数据列表':'數據列表',  
    '运动会管理':'運動會管理',  
    '新增运动会':'新增運動會',  
    '管理运动会':'管理運動會',  
    '编排':'編排',  
    '日程表':'日程表',  
    '运动风采':'運動風采',  
    '学校画像':'學校畫像',  
    '年级画像':'年級畫像',  
    '班级画像':'班級畫像',  
    '班级详情':'班級詳情',  
    '学生画像':'學生畫像',  
    '院系管理':'院系管理',  
    '专业管理':'專業管理',  
    '赛事列表':'賽事列表',  
    '新增闯关挑战赛':'新增闖關挑戰賽',  
    '编辑闯关挑战赛':'編輯闖關挑戰賽',  
    '闯关挑战赛详情':'闖關挑戰賽詳情',  
    '新增机构':'新增機構',  
    '编辑机构':'編輯機構',  
    '查看机构':'查看機構',  
    '组织结构管理':'組織結構管理',  
    '用户管理':'用戶管理',  
    '新增用户':'新增用戶',  
    '编辑用户':'編輯用戶',  
    '资源列表':'資源列表',
    '新增资源':'新增資源',
    '编辑资源':'編輯資源',
    '校本资源':'校本資源',
    '新增校本资源':'新增校本資源',
    '编辑校本资源':'編輯校本資源',
    // 2025.3.19

    // 2025.5.21
    'Banner配置':'Banner配置',  
    '编辑Banner配置':'編輯Banner配置',  
    '查看Banner配置':'查看Banner配置', 
    '资源分类':'資源分類​​', 

    // 2026.1.4
    '自由锻炼':'自由鍛煉',
    '趣味锻炼':'趣味鍛煉',
    '竞技场':'競技場',
    '机构主页管理':'機構主頁管理',
    '主页发布管理':'主頁發布管理',
    '分类管理':'分類管理',
    '新增主页':'新增主頁',
    '编辑主页':'編輯主頁',

    // 2026.6.25
    '宣传页管理':'宣傳頁管理',
    '宣传页配置':'宣傳頁配置',
    '新增宣传页':'新增宣傳頁',
    '编辑宣传页':'編輯宣傳頁',
}